// extracted by mini-css-extract-plugin
module.exports = {"container":"nUBKo5YgedhpW4zYxzc0k","arrowContainer":"_1nbxQI0KmvgrNjsHfACdOx","arrowRightContainer":"ssSLfWJDKL50D5P8uUrOz"};